<footer class="footer">
  <div class="footer-content">
    <div class="footer-logo">
      <a routerLink="/">
        <img src="assets/Hnet-Finalsvg-01-01.svg" alt="HorizonNet Logo">
      </a>
    </div>

    <div class="footer-links">
      <div class="link-group">
        <h3>QUICK LINKS</h3>
        <ul>
          <li>
            <a *ngIf="(isLoggedIn$ | async); else loginLink" routerLink="/dashboard/profile">
              <mat-icon>person</mat-icon>Mein Profil
            </a>
            <ng-template #loginLink>
              <a routerLink="/login"><mat-icon>login</mat-icon>Login</a>
            </ng-template>
          </li>
          <li><a routerLink="/blog"><mat-icon>article</mat-icon>Blog</a></li>
          <li><a routerLink="/faq"><mat-icon>help_outline</mat-icon>FAQ</a></li>
          <li><a href="#" (click)="$event.preventDefault(); openCookieSettings()"><mat-icon>tune</mat-icon>Cookie-Einstellungen</a></li>

        </ul>
      </div>

      <div class="link-group">
        <h3>RECHTLICHE LINKS</h3>
        <ul>
          <li><a routerLink="/agb"><mat-icon>gavel</mat-icon>AGB</a></li>
          <li><a routerLink="/widerruf"><mat-icon>assignment_return</mat-icon>Widerrufsrecht</a></li>
          <li><a routerLink="/disclaimer"><mat-icon>security</mat-icon>Disclaimer</a></li>
          <li *ngIf="(isOnDashboard$ | async)">
            <a routerLink="/partner-agreement"><mat-icon>group</mat-icon>Vertriebspartnervertrag</a>
          </li>
          <li><a routerLink="/geld-zurueck-garantie"><mat-icon>verified</mat-icon>Geld-zurück-Garantie</a></li>
          <li><a routerLink="/cookies"><mat-icon>cookie</mat-icon>Cookies</a></li>
        </ul>
      </div>

      <div class="link-group">
        <h3>KONTAKT</h3>
        <ul>
          <li>
            <a href="mailto:office@horizonnet-consulting.com" class="contact-link">
              <mat-icon>mail</mat-icon>
              office&#0064;horizonnet-consulting.at
            </a>
          </li>
          <li>
            <a routerLink="/kontakt"><mat-icon>link</mat-icon>zum Formular</a>
          </li>
        </ul>
      </div>

     
    </div>
  </div>

  <div class="footer-bottom">
    <div class="footer-bottom-content">
      <p>© {{currentYear}} HorizonNet Consulting, alle Rechte vorbehalten</p>
      <div class="legal-links">
        <a routerLink="/impressum">Impressum</a>
        <span class="separator">|</span>
        <a routerLink="/datenschutz">Datenschutz</a>
      </div>
    </div>
  </div>
</footer> 